import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { NotificationTemplate, NotificationTemplateCreate, NotificationTemplateFilter } from '../data/notificationTemplate';

export function createNotificationTemplateService(client: AxiosInstance) {
  return createCrudService<NotificationTemplate, NotificationTemplateCreate, NotificationTemplateFilter>(
    client,
    '/notifications/NotificationTemplate',
    'id',
  );
}

export type NotificationTemplateService = CrudService<NotificationTemplate, NotificationTemplateCreate, NotificationTemplateFilter>;
